import { Component } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { CreditsPage } from '../credits/credits.page';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy.page';

@Component({
  selector: 'app-about',
  templateUrl: 'about.html',
  styleUrls: [
    './styles/about.scss'
  ]
})
export class AboutPage {

  constructor(
    public modalController: ModalController
  ) { }

  openUrl(url: string) {
    window.open(url, '_blank');
  }

  dismiss(data?: any) {
    this.modalController.dismiss(data);
  }

  async showPrivacy() {
    const modal = await this.modalController.create({
      component: PrivacyPolicyPage,
      componentProps: { isDialog: true }
    });
    return await modal.present();
  }

  async showCredits() {
    const modal = await this.modalController.create({
      component: CreditsPage,
      componentProps: { isDialog: true }
    });
    return await modal.present();
  }

  gotoSite(url: string) {
    window.open(url, '_blank');
  }
}
